// extracted by mini-css-extract-plugin
export var container = "_e3-0";
export var content = "_e3-3";
export var customerTitle = "_e3-4";
export var empty = "_e3-5";
export var gray = "_e3-6";
export var header = "_e3-7";
export var info = "_e3-8";
export var loading = "_e3-2";
export var loadingCard = "_e3-9";
export var oneLine = "_e3-a";
export var personName = "_e3-e";
export var pillContainer = "_e3-b";
export var selected = "_e3-1";
export var text = "_e3-c";
export var twoLines = "_e3-d";
export var unread = "_e3-f";
export var unreadIndicator = "_e3-g";